// Base success response
export type ResponseSuccess<T = unknown> = {
  code: number;
  message: string;
  data?: T;
  fromCache?: boolean;
};

// Base error response
export type ResponseError = {
  code: number;
  message: string;
  data?: unknown;
  error?: unknown;
};

// Union type
export type ApiResponse<T = unknown> = ResponseSuccess<T> | ResponseError;

// Generic list response type for paginated endpoints
export interface ListResponse<T> {
  items: T[];
  pagination: {
    next_cursor: string | null;
    prev_cursor: string | null;
    has_next: boolean;
    has_prev: boolean;
    total?: number | null;
  };
}

// Type guard to check if response is successful
export function isResponseSuccess<T>(response: ApiResponse<T> | undefined): response is ResponseSuccess<T> {
  return response !== undefined && 'code' in response && Math.floor(response.code / 100) === 2;
}
